(function () {
    angular.module("EventListApp")
        .filter('padZero', function () {
            return function (num, length) {
                return (num.toString().length < length) ? ('0'.repeat(length - num.toString().length) + num) : num;
            };
        })
        .directive('countdown', ['$interval', function ($interval) {
            return {
                restrict: 'E',
                scope: {
                    endDate: '@',    // End date as a string
                    refresh: '@',    // Refresh rate in milliseconds
                    offset: '@',     // Timezone offset in hours
                    onEnd: '&'       // Callback function when countdown ends
                },
                template:
                    '<div class="countdown">' +
                    '<div class="part">' +
                    '<div class="value">{{countdown.days}}</div>' +
                    '<div class="text">days</div>' +
                    '</div>' +
                    '<div class="part">' +
                    '<div class="value">{{countdown.hours | padZero:2}}</div>' +
                    '<div class="text">hours</div>' +
                    '</div>' +
                    '<div class="part">' +
                    '<div class="value">{{countdown.minutes|padZero:2 }}</div>' +
                    '<div class="text">minutes</div>' +
                    '</div>' +
                    '<div class="part">' +
                    '<div class="value">{{countdown.seconds | padZero:2}}</div>' +
                    '<div class="text">seconds</div>' +
                    '</div>' +
                    '</div>',
                link: function (scope, element, attrs) {
                    // Convert input values to appropriate types
                    var endDate = new Date(scope.endDate);
                    scope.refresh = parseInt(scope.refresh) || 1000;
                    scope.offset = parseInt(scope.offset) || 0;
                    var interval;

                    // Start the countdown
                    scope.start = function () {
                        updateCountdown();
                        interval = $interval(updateCountdown, scope.refresh);
                    };

                    // Stop the countdown
                    scope.stop = function () {
                        if (interval) {
                            $interval.cancel(interval);
                            interval = null;
                        }
                    };

                    // Initialize the countdown
                    // Check if endDate is a valid date and in the future
                    if (endDate && isValidDate(endDate)) {
                        scope.start();
                    }

                    // Cleanup on directive destroy
                    scope.$on('$destroy', function () {
                        scope.stop();
                    });


                    // Function to calculate the difference between the current time and the end date
                    function getDiffDate() {
                        var now = new Date();
                        var diff = (endDate.getTime() - now.getTime() + (scope.offset * 3600000)) / 1000;

                        return {
                            days: Math.floor(diff / 86400),
                            hours: Math.floor((diff % 86400) / 3600),
                            minutes: Math.floor((diff % 3600) / 60),
                            seconds: Math.floor(diff % 60)
                        };
                    }

                    // Function to update the countdown display
                    function updateCountdown() {
                        var countdown = getDiffDate();
                        scope.countdown = countdown;

                        if (countdown.days <= 0 && countdown.hours <= 0 &&
                            countdown.minutes <= 0 && countdown.seconds <= 0) {
                            scope.stop();
                            if (angular.isFunction(scope.onEnd)) {
                                scope.onEnd();
                            }
                        }
                    }

                    function isValidDate(d) {
                        return d instanceof Date && !isNaN(d.getTime());
                    }

                }
            };
        }])
})();